import React from "react";
import NavigationBar from "../components/NavigationBar/NavigationBar";
import Footer from "../components/Footer/Footer";
import styles from "./MainLayout.module.css";

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className={styles.layout}>
          <NavigationBar />

        <main className={styles.main}> 
          {children}
        </main>

        <Footer />
  </div>
  );
};

export default MainLayout;
